export var getFreeDeliveryUpselling = function (basketStatus) {
    return basketStatus.upselling.find(function (item) { return item.type === 'free_delivery'; }) || null;
};
export var getMinDeliveryUpselling = function (bs) {
    return bs.upselling.find(function (item) { return item.type === 'delivery_min_cart_amount'; }) || null;
};
export var getIsMinDeliveryAchieved = function (basketStatus) { return !getMinDeliveryUpselling(basketStatus); };
export var getFreeDeliveryDiscount = function (bs) {
    return bs.discounts.find(function (item) { return item.type === 'freeDelivery'; });
};
var BasketStatus = {
    getFreeDeliveryDiscount: getFreeDeliveryDiscount,
    getFreeDeliveryUpselling: getFreeDeliveryUpselling,
    getMinDeliveryUpselling: getMinDeliveryUpselling,
    getIsMinDeliveryAchieved: getIsMinDeliveryAchieved,
};
export default BasketStatus;
